import { createFileRoute, notFound } from '@tanstack/react-router';
import { z } from 'zod';
import { FeatureFlag, RouteName } from '@mews-commander/enums';
import {
    AnalyticsType,
    checkAnalyticsPrivilege,
    fetchAnalytics,
    mapAnalyticsTypeTextKey,
    PowerBi,
} from '@mews-commander/modules/src/modules/powerBi';
import { MewsTeam, RouteType } from '@mews/enums';

const getAnalyticsType = (type: string) => AnalyticsType[type as AnalyticsType] || AnalyticsType.Manager;

const Component = () => {
    const { type } = Route.useSearch();
    const analyticsType = getAnalyticsType(type);

    return <PowerBi analyticsType={analyticsType} />;
};

export const Route = createFileRoute('/_authenticated/$currentEnterpriseId/Analytics/Index/')({
    validateSearch: z.object({
        type: z.string(),
    }),
    beforeLoad: ({
        context: {
            getState__DO_NOT_USE_OR_YOU_WILL_BE_FIRED: getState,
            checkFeatureFlag,
            dispatch__DO_NOT_USE_OR_YOU_WILL_BE_FIRED: dispatch,
        },
        search,
    }) => {
        checkFeatureFlag(FeatureFlag.mewsAnalyticsEnabled);

        const check = checkAnalyticsPrivilege(getState());
        if (!check) {
            throw notFound();
        }

        const { type } = search;
        const analyticsType = getAnalyticsType(type);

        fetchAnalytics(dispatch, analyticsType);

        return {
            getTitle: () => ({
                textKey: mapAnalyticsTypeTextKey[analyticsType],
            }),
        };
    },
    component: Component,
    staticData: {
        routeName: RouteName.AnalyticsIndex,
        owner: MewsTeam.Analytics,
        type: RouteType.Frontend,
    },
});
